import { render, staticRenderFns } from "./PeppolEndpointsEditor.vue?vue&type=template&id=13d981cc&scoped=true"
import script from "./PeppolEndpointsEditor.vue?vue&type=script&lang=ts"
export * from "./PeppolEndpointsEditor.vue?vue&type=script&lang=ts"
import style0 from "./PeppolEndpointsEditor.vue?vue&type=style&index=0&id=13d981cc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d981cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d981cc')) {
      api.createRecord('13d981cc', component.options)
    } else {
      api.reload('13d981cc', component.options)
    }
    module.hot.accept("./PeppolEndpointsEditor.vue?vue&type=template&id=13d981cc&scoped=true", function () {
      api.rerender('13d981cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/peppol/PeppolEndpointsEditor.vue"
export default component.exports